// CUSTOM ACCORDION

window.faqSec = true;
document.querySelectorAll(".accordion .details summary").forEach((element) =>
  element.addEventListener("click", (event) => {
    event.preventDefault();
    const detailsElement = event.target.parentElement;
    const contentElement = event.target.nextElementSibling;
    const contentInvisibleElement = contentElement.nextElementSibling;
    const height = contentInvisibleElement.offsetHeight;

    detailsElement.classList.toggle("active");

    if (detailsElement.classList.contains("active")) {
      contentElement.style.height = `${height}px`;
    } else {
      contentElement.style.height = "0px";
    }
  })
);
